import { IntegrationAvatar, AvatarSize } from "../MergeAvatars";
import { Integration } from "../../../models/Entities";
import { Text, Badge } from "@merge-api/merge-javascript-shared";

type Props = {
  integration: Integration;
  header: string;
  subheader: string;
  hasUnsavedChanges?: boolean;
};

const HeaderSection = ({ integration, header, subheader, hasUnsavedChanges }: Props) => {
  return (
    <div>
      <Text variant="h4" className="pb-2">
        {header}
      </Text>
      <div className="flex flex-row items-center gap-x-1.5">
        <IntegrationAvatar integration={integration} size={AvatarSize.xs} />
        <Text variant="h5">{subheader}</Text>
        {hasUnsavedChanges && <Badge color="red">Unsaved changes</Badge>}
      </div>
    </div>
  );
};

export default HeaderSection;
